import React from "react";
import getConfig from "next/config";
import Link from "next/link";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ages = [
  {
    img: "1-2-ani",
    value: "6-9-luni_9-12-luni_1-2-ani_2-3-ani",
  },
  {
    img: "3-4-ani",
    value: "2-3-ani_3-4-ani_4-5-ani",
  },
  {
    img: "5-7-ani",
    value: "4-5-ani_5-6-ani_6-7-ani",
  },
  {
    img: "8-10-ani",
    value: "7-8-ani_8-9-ani_9-10-ani",
  },
  {
    img: "10-12-ani",
    value: "10-11-ani_11-12-ani",
  },
  {
    img: "12-plus-ani",
    value: "peste-12-ani",
  },
];

const LegoByAge = () => (
  <div className="">
    <div className="mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]">
      <img
        src={`${settings.websiteStatics}/images/universul-lego/age_title.png`}
        alt=""
      />
    </div>

    <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
      {ages.map(({ img, value }, index) => (
        <li key={index}>
          <Link href={`/lego-jucarii/cpl/filtru/varsta-8282/${value}/`}>
            <a title="">
              <img
                src={`${settings.websiteStatics}/images/universul-lego/varsta/${img}.png`}
                alt=""
              />
            </a>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default LegoByAge;
